import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=6b5dd932&scoped=true&"
import script from "./MessageBody.vue?vue&type=script&lang=js&"
export * from "./MessageBody.vue?vue&type=script&lang=js&"
import style0 from "./MessageBody.vue?vue&type=style&index=0&id=6b5dd932&lang=scss&scoped=true&"
import style1 from "./MessageBody.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5dd932",
  null
  
)

export default component.exports